import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import SearchIcon from '@mui/icons-material/Search';
import CameraAltIcon from '@mui/icons-material/CameraAlt'; // Added
import StyleIcon from '@mui/icons-material/Style'; // Added (for binding types)
import DevicesIcon from '@mui/icons-material/Devices'; // Added (for multiple inputs)

const Home: React.FC = () => {
  return (
    <Box sx={{ flexGrow: 1, py: 2 }}> {/* Added vertical padding */}
      <Paper
        elevation={3}
        sx={{
          p: { xs: 3, md: 5 }, // Responsive padding
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          borderRadius: 3, // Slightly more rounded
          mb: 6, // Increased bottom margin
        }}
      >
        <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
          Welcome to CoverVision
        </Typography>
        <Typography variant="h5" component="h2" color="text.secondary" gutterBottom> {/* Use secondary text color */}
          Match book covers to ISBNs with AI-powered image recognition
        </Typography>
        <Typography variant="body1" paragraph sx={{ maxWidth: 700, mb: 4, color: 'text.secondary' }}> {/* Slightly narrower, secondary color */}
          CoverVision uses advanced AI to match book cover images to ISBNs. Simply take a photo of a book cover or upload an image, and our system will identify the book and provide its ISBN. Perfect for inventory management, cataloging, or finding information about books.
        </Typography>

        <Grid container spacing={2} justifyContent="center" sx={{ mb: 2 }}> {/* Added bottom margin */}
          <Grid item>
            <Button
              variant="contained"
              size="large"
              startIcon={<SearchIcon />}
              component={RouterLink}
              to="/search"
            >
              Start Searching
            </Button>
          </Grid>
        </Grid>
      </Paper>

      {/* Feature Section */}
      <Grid container spacing={4} sx={{ mt: 6 }}> {/* Increased top margin */}
        <Grid item xs={12} md={4}>
          <Paper elevation={2} sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', borderRadius: 2 }}>
            <CameraAltIcon color="primary" sx={{ fontSize: 40, mb: 2 }} />
            <Typography variant="h6" component="h3" gutterBottom> {/* Changed to h6 */}
              Image Recognition
            </Typography>
            <Typography variant="body2" color="text.secondary"> {/* Changed to body2, secondary color */}
              Our system uses state-of-the-art image recognition to identify book covers, even in less-than-ideal lighting conditions or angles.
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper elevation={2} sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', borderRadius: 2 }}>
            <StyleIcon color="primary" sx={{ fontSize: 40, mb: 2 }} />
            <Typography variant="h6" component="h3" gutterBottom> {/* Changed to h6 */}
              Binding Type Support
            </Typography>
            <Typography variant="body2" color="text.secondary"> {/* Changed to body2, secondary color */}
              Toggle between hardcover and paperback to ensure accurate matching, as the same book may have different ISBNs depending on binding.
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper elevation={2} sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', borderRadius: 2 }}>
            <DevicesIcon color="primary" sx={{ fontSize: 40, mb: 2 }} />
            <Typography variant="h6" component="h3" gutterBottom> {/* Changed to h6 */}
              Multiple Input Methods
            </Typography>
            <Typography variant="body2" color="text.secondary"> {/* Changed to body2, secondary color */}
              Use your webcam to capture images directly, upload image files, or even scan a QR code with your phone to send images from your mobile device.
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Home;
